webpackJsonp([118219157657086],{

/***/ 1557:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SpeciesDosageConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"maxDose","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Decimal","ofType":null}}},{"defaultValue":null,"description":null,"name":"minDose","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Decimal","ofType":null}}},{"defaultValue":null,"description":null,"name":"speciesIds","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID"}}}}},{"defaultValue":null,"description":null,"name":"treatmentType","type":{"kind":"ENUM","name":"DosageTreatmentType","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-species-dosage-config-input-c28ec23b2b600486a237.js